import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=5f158198&scoped=true"
import script from "./topicDetails.vue?vue&type=script&lang=js"
export * from "./topicDetails.vue?vue&type=script&lang=js"
import style0 from "./topicDetails.vue?vue&type=style&index=0&id=5f158198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f158198",
  null
  
)

export default component.exports